<template>
  <tr>
    <td>
      {{ itemStart }} - {{ itemEnd }}
    </td>
    <td>
      {{ item.weeks }}
    </td>
    <td>
      <div>
        <BaseTooltip :tooltip="status.text">
          <IconsFinanceSalaryStatus class="mt-1"/>
        </BaseTooltip>
      </div>
    </td>
    <td class="d-flex justify-end">
      <ButtonShow :openModal="onOpenPeriod"/>
    </td>
  </tr>
</template>

<script>
import ButtonShow from "../../ButtonShow";
import IconsFinanceSalaryStatus from "components/icons/finance/IconsFinanceSalaryStatus";

export default {
  name: "FinanceSalarySliceTableItem",
  components: {IconsFinanceSalaryStatus, ButtonShow},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    itemStart() {
      if (this.item.start) return this.toDate(this.item.start)
      return ''
    },
    itemEnd() {
      if (this.item.end) return this.toDate(this.item.end)
      return ''
    },
    status() {
      switch (this.item.status) {
        case 'new':
          return {
            color: 'blue',
            text: this.localStorage.translations.pages.finance['invoice-status']['created']
          }
        case 'done':
          return {
            color: 'green',
            text: this.localStorage.translations.pages.finance['invoice-status']['paid']
          }
        default:
          return {
            color: 'yellow',
            text: this.localStorage.translations.pages.finance['invoice-status']['part_paid']
          }
      }
    }
  },
  methods: {
    toDate(data) {
      return data.split('/').join('.')
    },
    onOpenPeriod() {
      this.$router.push({
        name: 'financeSalarySliceShow',
        params: {period_id: this.item.id},
      })
    },
  }
}
</script>

<style scoped lang="scss">
.height {
  height: max-content;
}

:deep() .base-tooltip {
  width: min-content;
}
</style>
